// extracted by mini-css-extract-plugin
export default {"container":"QFSspZHwuE","pagination":"LWecqH2DKz","pagination-cell":"YRSghc5lqM","paginationCell":"YRSghc5lqM"};